// Copyright (c) Ping. All rights reserved.
//
// Stable identifiers for the product tours. The id is baked into the
// per-user "seen" flag (`tour.<id>.seen` in settings_kv) and into the
// cross-device `com.ping.tour_seen` mirror payload, so it must stay
// stable once shipped. Bump the version suffix (e.g. `home_v2`) to
// deliberately re-show a tour after a redesign.

export type TourId = 'home' | 'settings' | 'pane-guide';

export const TOUR_HOME: TourId = 'home';
export const TOUR_SETTINGS: TourId = 'settings';
// On-demand, per-pane guide launched from the floating button inside a
// settings pane. Runs manually (never auto-starts, never marks seen).
export const TOUR_PANE_GUIDE: TourId = 'pane-guide';
